import { Currency } from '@sequencehq/api'
import {
  BaseCreditNoteLineItemDrawer,
  FormValues
} from './BaseCreditNoteLineItemDrawer'
import { LineItem } from 'CreditNotes/types'
import { percentageFromDecimal } from '@sequencehq/utils'
import type { Dashboardv99990101CommonModels } from '@sequencehq/api/dashboard/v99990101'

type CreditNoteLineItemRateDisplay =
  Dashboardv99990101CommonModels.CreditNoteLineItems.CreditNoteLineItemRateDisplay
import { SubmitValues } from './BaseCreditNoteLineItemDrawer'
export type { SubmitValues } from './BaseCreditNoteLineItemDrawer'

interface Props {
  isOpen: boolean
  onClose: () => void
  onSubmit: (formValues: SubmitValues) => Promise<boolean>
  creditNoteCurrency: Currency
  creditNoteLineItem: LineItem
}

export const EditCreditNoteLineItemDrawer = ({
  isOpen,
  onClose,
  onSubmit,
  creditNoteCurrency,
  creditNoteLineItem
}: Props) => {
  const initialValues: FormValues = {
    title: creditNoteLineItem.title,
    description: creditNoteLineItem.description ?? '',
    rateDisplay: creditNoteLineItem.rateDisplay,
    quantity: creditNoteLineItem.quantity,
    amount: applyRateDisplay(
      creditNoteLineItem.rate,
      creditNoteLineItem.rateDisplay
    ),
    tax: percentageFromDecimal(creditNoteLineItem.taxRate),
    productId: creditNoteLineItem.productId,
    taxCategoryId: creditNoteLineItem.taxCategoryId ?? '',
    servicePeriod: creditNoteLineItem.servicePeriod,
    revenueRecognitionMethod: creditNoteLineItem.revenueRecognitionMethod
  }

  return (
    <BaseCreditNoteLineItemDrawer
      initialValues={initialValues}
      initialTaxRate={creditNoteLineItem.taxRate}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      creditNoteCurrency={creditNoteCurrency}
      title="Edit line item"
      submitButtonText="Update"
    />
  )
}

function applyRateDisplay(
  value: string,
  rateDisplay: CreditNoteLineItemRateDisplay
) {
  return rateDisplay === ('ABSOLUTE' satisfies CreditNoteLineItemRateDisplay)
    ? value
    : percentageFromDecimal(value)
}
